<script setup lang="ts">
  import { computed } from "vue";
  import { Text, Button, IconListCompleted } from "@ui-kit";
  import { type OrderType } from "@src/api";

  const emit = defineEmits<{ (e: "close"): void; (e: "toOrders"): void }>();
  const { order_type } = defineProps<{ order_type?: OrderType | string }>();

  type CompletedViewConfig = {
    id: string;
    subtitle: string;
  };

  const completed_view_config_by_type: Record<OrderType, CompletedViewConfig> = {
    "pickup": { id: "pickup", subtitle: "Отнесите заказ в зал" },
    "online": { id: "online", subtitle: "Отнесите заказ в зал" },
    "pickup.device": { id: "pickup.device", subtitle: "Отнесите заказ в зал" },
    "pickup.commerce": {
      id: "pickup.commerce",
      subtitle: "Отнесите заказ в зону коммерческих запросов",
    },
  };

  const completed_view_config = computed(
    () => completed_view_config_by_type[(order_type as OrderType) ?? "pickup"] ?? completed_view_config_by_type["pickup"],
  );
</script>

<template>
  <div class="order-completed" data-testid="order-completed">
    <div class="content">
      <IconListCompleted />
      <div class="description">
        <Text font="heading-H4">{{ `${$t("Запрос выполнен")}!` }}</Text>
        <Text color="secondary" :data-testid="`order-completed-subtitle-${completed_view_config.id}`">
          {{ $t(completed_view_config.subtitle) }}
        </Text>
      </div>
    </div>
    <Button variant="secondary" @click="emit('close')" data-testid="order-completed-to-main-btn">
      {{ $t("На главную") }}
    </Button>
    <Button @click="emit('toOrders')" data-testid="order-completed-to-orders-btn">{{ $t("В запросы") }}</Button>
  </div>
</template>

<style scoped>
  .order-completed {
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 8px;
    padding: 16px;

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      flex: 1;
      gap: 24px;
    }

    .description {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: 8px;
    }

    & :deep(.button) {
      width: 100%;
    }
  }
</style>
